import { Component, ViewChild } from '@angular/core';
import { BuscarSisbenComponent, CustomTitle, IsearchJefeHogar, LoadingPanelService } from 'lib-base';
import { DividerModule } from 'primeng/divider';
import { TipoIdentificacionService } from '../../../services/database/tipoIdentificacion.service';
import { ConsultaSisbenResultadosComponent } from "./consulta-sisben-resultados.component";
import { ITipoIdentificacion } from '../../../shared/interfaces/database/seguridad';
import { SisbenConsultaService } from '../../../services/sisben/sisben-consulta.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-consulta-sisben',
  standalone: true,
  imports: [
    CustomTitle, DividerModule, BuscarSisbenComponent,
    ConsultaSisbenResultadosComponent
  ],
  template: `
  <section class="flex justify-content-center mt-4">
    <div class="card-table col-12 flex flex-column">
        <CustomTitle [title]="'Consulta SISBEN'"
          styleClass="font-principal color-form-label font-medium font-23 text-uppercase mt-3 ml-6 "/>        
        <app-buscar-sisben 
          (sisben)="getSearchValues($event)" 
          (clearSearch)="clearSearch()"
          [tiposIdentificaciones]="tiposIdentificaciones"/>
        <p-divider class="px-6 w-full h-3rem"/>
        <app-consulta-sisben-resultados #resultadosComponent></app-consulta-sisben-resultados>
    </div>
  </section>
  `
})
export class ConsultaSisbenComponent {

  tiposIdentificaciones: ITipoIdentificacion[] = [];

  @ViewChild(BuscarSisbenComponent) buscarComponent!: BuscarSisbenComponent;
  @ViewChild(ConsultaSisbenResultadosComponent) resultadosComponent!: ConsultaSisbenResultadosComponent;

  constructor(
    private readonly _tis: TipoIdentificacionService,
    private readonly _scs: SisbenConsultaService,
    private readonly _lps: LoadingPanelService
  ) {
    this.getTipoIdentificacion();
  }

  //#region buscar-sisben 
  clearSearch() {
    if (this.resultadosComponent) {
      this.resultadosComponent.clearData();
      this.buscarComponent.existData = false;
    }
  }

  getSearchValues($event: IsearchJefeHogar) {
    this.resultadosComponent.props = $event;
    this._lps.show(true);
    firstValueFrom(this._scs.sisbenResultadoConsulta($event.identificacion, Number($event.tipoIdentificacion)))
      .then(data => {
        this._lps.hide();
        this.resultadosComponent.setResultados(data);
        this.buscarComponent.existData = true;
      });
  }

  private getTipoIdentificacion() {
    this._tis.getTipoIdentificaciones().subscribe({
      next: data => {
        this.tiposIdentificaciones = data;
      }
    })
  }
  // #endregion buscar-sisben
}
